<template>
    <div class="paper-detail">
        <div v-if="isDEV">
            <simple-code :data="text"></simple-code>
            <a class="paper-primary-text" @click="handleBoke">Voice paper <SafeIcon type="ai-yinpin"/></a>
            <br/>
            <SafeIcon type="fanhui" class="top-icon"/>
            <ShareAltOutlined class="top-icon"/>
            <!-- 使用figure和figcaption语义化标签 -->
            <SafeIcon type="boke" :size="24" color="#1890ff" />
            <SafeIcon type="fanhui" />
            <SafeIcon type="ai-yinpin" class="audio-icon audio-active"/>
            <span class="top-icon" style="float: right; font-size: 14px">
                                                    <ShareAltOutlined/>
                                                </span>
            <MobileImg v-if="account === 'test'"/>
            <a-row :gutter="16">
                <a-col :sm="12" :xs="24">
                    <div class="content">
                        <PdfPptAudio  :data="ppt"/>
                    </div>
                </a-col>
            </a-row>
        </div>
        <a-spin :spinning="loading">
            <a-row :gutter="16">
                <a-col :sm="12" :xs="24">
                    <div class="content">
                        <div v-if="loading" style="padding: 200px;"></div>
                        <div  v-else>
                            <div>
                                <div v-if="isPhone">
                                    <a-affix :offset-top="10">
                                        <div style="margin-bottom: 15px; margin-top: 5px">
                                            <a-row>
                                                <a-col span="12">
                                                    <div style="margin-top: 5px;">
                                                        <RollBack height="18px"/>
                                                    </div>
                                                </a-col>
                                                <a-col span="12" style="text-align: right;">
                                                    <a-dropdown v-if="shareable">
                                                        <ShareAltOutlined class="top-icon"/>
                                                        <template #overlay>
                                                            <a-menu>
                                                                <a-menu-item>
                                                                    <a-typography-text :copyable="{ text: href }">
                                                                        分享链接
                                                                    </a-typography-text>
                                                                </a-menu-item>
                                                                <a-menu-item @click="()=> openQRCode = true">
                                                                    分享图片 <PictureTwoTone style="margin-left: 4px"/>
                                                                </a-menu-item>
                                                            </a-menu>
                                                        </template>
                                                    </a-dropdown>
                                                    <a-tooltip v-else :title="shareTip">
                                                        <ShareAltOutlined class="top-icon"/>
                                                    </a-tooltip>
                                                </a-col>
                                            </a-row>

                                        </div>
                                    </a-affix>
                                </div>
                                <h1 style="font-size: 22px; font-weight: 600;padding: 0 10px;">
                                    <span @click="goToPubmed" style="cursor: pointer">
                                        {{paper.title_cn}}
                                    </span>
                                    <span v-if="!isPhone">
                                        <a-dropdown v-if="shareable">
                                            <a @click.prevent><ShareAltOutlined/></a>
                                            <template #overlay>
                                                <a-menu>
                                                    <a-menu-item>
                                                        <a-typography-text :copyable="{ text: href }">
                                                            分享链接
                                                        </a-typography-text>
                                                    </a-menu-item>
                                                    <a-menu-item @click="()=> openQRCode = true">
                                                        分享图片 <PictureTwoTone style="margin-left: 4px"/>
                                                    </a-menu-item>
                                                </a-menu>
                                            </template>
                                        </a-dropdown>
                                        <a-tooltip v-else :title="shareTip">
                                            <a><ShareAltOutlined/></a>
                                        </a-tooltip>
                                    </span>
                                </h1>
                            </div>
                            <div class="auto-wrap"
                                 style="line-height: 24px; text-align: justify"
                            >
                                <div>
                                    <div class="content1" style="padding-top: 0; padding-bottom: 0;margin-bottom: 0">
                                        <div style="line-height: 16px;font-size: 14px;">
                                            <a-tag color="#1281FF" v-if="paper.article_type">{{paper.article_type}}</a-tag>
                                            <span style="color: #666" v-if="paper.title">
                                                {{paper.title}}
                                            </span>
                                            <span  v-if="paper.jif !=='NA'" style="color:#C00000; float: right">
                                                [{{paper.jif}}]
                                            </span>
                                        </div>
                                        <div style="border-bottom: 1px solid #DADADA;font-size: 14px;">
                                            <span class="paper-primary-text">
                                            <i v-if="paper.journal_title !=='NA'">{{paper.journal_title}}</i>
                                            <span v-if="paper.pub_year">.{{paper.pub_year}}</span>
                                        </span>
                                        </div>

                                        <div class="auto-wrap" style="margin-top: 15px">
                                                <AuthorOrganization title="作者及单位" :text="paper.authors" :extra="paper.organization">
                                                    <template #extra1>
                                                        <show-all title="" :text="paper.organization" :initLen="1"/>
                                                    </template>
                                                </AuthorOrganization>
                                        </div>
                                        <div style="margin-top: 15px">
                                            <b>摘要</b>
                                            <p style="line-height: 28px">{{paper.abstract_cn}}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="v-tab">
                                            <span :class="'tab-left ' + (checked1? 'active-tab': '')" @click="toggleTab">
                                                <ReadOutlined /> 全文拆解
                                            </span>
                                            <span :class="'tab-right ' + (checked1? '': 'active-tab')" @click="toggleTab">
                                                <SafeIcon type="aishipin"/> 视频讲解
                                            </span>
                                        </div>
                                        <div class="content1">
                                            <div v-if="checked1">
                                                <a-collapse :bordered="false" class="ant-collapse-blue-arrow">
                                                    <template #expandIcon="{ isActive }">
                                                        <right-outlined class="paper-primary-text" :rotate="isActive ? 90 : 0" />
                                                    </template>

                                                    <template v-for="(aiItem, index) in aiItems" :key="index">
                                                        <a-collapse-panel style="background: #FFF">
                                                            <template #header>
                                                                <span class="paper-primary-text" style="font-size: 18px;">{{aiItem.title}}</span>
                                                            </template>
                                                            <div class="gpt-font ai-text">
                                                                <simple-code :data="paper[aiItem.key]" :len="100" :no-tip="true"/>
                                                            </div>
                                                        </a-collapse-panel>
                                                    </template>
                                                </a-collapse>
                                            </div>
                                            <div v-else>
                                                <div>
                                                    <small v-if="paper?.video_parse_info?.step < 0">
                                                        AI视频生成失败，
                                                        <a class="paper-primary-text" @click="fankui">
                                                        点击
                                                    </a>上报给管理员。
                                                    </small>
                                                    <template v-else-if="paper?.video_parse_info?.step === 0">
                                                        <div style="padding: 30px">
                                                            <paper-wait-steps/>
                                                        </div>
                                                        <p>
                                                            <small>
                                                                <a-space>
                                                                    目前视频生成请求较多，您的任务正在排队处理<LoadingComponent/>
                                                                </a-space>
                                                            </small>
                                                        </p>
                                                        <p>
                                                            <small>
                                                                您可以先查看
                                                                <a class="paper-primary-text" @click="()=>checked1=true">
                                                                全文拆解
                                                            </a>，或者先听一下
                                                                <a class="paper-primary-text" @click="handleBoke">VoicePaper <SafeIcon type="boke"/></a>
                                                            </small>
                                                        </p>
                                                        <p>
                                                            <small>若您不想等待，也可以直接关闭页面，之后在 <a class="paper-primary-text" @click="goToRecent">最新阅读</a>里查看结果。</small>
                                                        </p>
                                                    </template>
                                                    <template v-else-if="paper?.video_parse_info?.step < 4">
                                                        <pdf-img  v-if="Array.isArray(paper?.video_parse_info?.pdf_page)" :data="paper.video_parse_info.pdf_page"/>
                                                        <p>
                                                            <small v-if="paper?.video_parse_info?.step <= 2">
                                                                <a-space>
                                                                    正在进行课件生成，预计还需2～4分钟生成AI视频<LoadingComponent/>
                                                                </a-space>
                                                            </small>
                                                        </p>
                                                    </template>

                                                    <template v-else-if="paper?.video_parse_info?.step >= 4">
                                                        <template v-if="showFullVideo">
                                                            <pubmed-media
                                                                    :ppts="paper?.video_parse_info?.ppt_list"
                                                                    cn="视频" media="video" :progress="progress" :status="paper.video_status" :paper-no="paper_no" :url="paper.video_url"/>
                                                            <div style="text-align: center">
                                                                <small>
                                                                    切换到<a class="paper-primary-text" @click="()=>showFullVideo=false">课件播放</a>模式
                                                                </small>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <PdfPptAudio  v-if="(!showFullVideo) && Array.isArray(paper?.video_parse_info?.ppt_list)" :data="paper.video_parse_info.ppt_list"/>
                                                            <div style="text-align: center">
                                                                <small>
                                                                    切换到<a class="paper-primary-text" @click="()=>showFullVideo=true">视频播放</a>模式
                                                                </small>
                                                            </div>
                                                        </template>
                                                    </template>
                                                    <small v-else-if="paper?.embedding  < 0">
                                                        视频生成过程发生未知错误，您可<a class="paper-primary-text" @click="fankui">
                                                        点击
                                                    </a>上报此问题给管理员或重新上传。
                                                    </small>
                                                    <small v-else>
                                                        正在生成AI视频，预计需要5分钟...
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="account" class="content1">
                                    <paper-chat
                                            :embedding="paper.embedding"
                                            :paper_no="paper.paper_no"
                                            :handle-search="handleSearchText"
                                            :handle-page="handlePageJump"
                                            :handle-minus="handleMinus"
                                            :chatable="paper.status >= 4"
                                    />
                                </div>

                                <div v-else style="border-radius: 5px; border: 1px dashed #eee; padding: 50px; text-align: center;">
                                    <span><a href="/login" class="paper-primary-text">登录</a>后开启进阶体验：上传文献、视频讲解、交互问答，让科研更高效。</span>
                                </div>
                                <a-affix :offset-bottom="-2">
                                <div id="boke">
                                    <p v-if="paper?.audio_parse_info.status === -2">
                                        <small>文件大小超出 20M 限制，暂不支持生成Voice paper，您可查看<a class="paper-primary-text" @click="()=>showFullText=true">
                                            全文拆解
                                        </a>和<a class="paper-primary-text" @click="()=> checked1 = false">
                                            视频讲解
                                        </a>。</small>
                                    </p>
                                    <p v-else-if="paper?.audio_parse_info.status < 0">
                                        <small>Voice paper生成过程发生未知错误，您可<a class="paper-primary-text" @click="fankui">
                                            点击
                                        </a>上报此问题给管理员或重新上传。</small>
                                    </p>
                                    <VoicePaper v-else
                                            :paper="paper"
                                            :data="paper?.audio_parse_info||{}"
                                            :title="paper.title_cn"
                                            :play-boke="playBoke"
                                    />
                                </div>
                                </a-affix>
                            </div>
                        </div>

                        <a-modal v-model:open="open" :title="modalTitle" @ok="()=>open = false" width="800px" :footer="null">
                            <div style="margin-bottom: 20px;max-height: 420px; overflow-y: auto; padding-right: 5px;" class="gpt-font">
                                <simple-code :data="modalData" :len="100" :no-tip="true"/>
                            </div>
                        </a-modal>
                        <a-modal v-model:open="openQRCode" class="modal-width" :footer="null">
                            <a-row align="bottom" :gutter="8">
                                <a-col span="22" style="overflow-y: auto;position: relative">
                                    <div v-if="isPhone" style="text-align: right">
                                        <small style="display: none" id="mobile-tip"><SafeIcon type="zhixiangxia"/> 长按保存或分享图片</small>
                                    </div>
                                    <div style="background: #F2F2F2; border-radius: 5px; padding: 15px 10px; z-index: 0" id="card">
                                        <h3 style="line-height: 24px;">
                                            {{paper.title_cn}}
                                        </h3>
                                        <p>
                                            <span class="paper-primary-text">
                                                <i v-if="paper.journal_title !=='NA'">{{paper.journal_title}}</i>
                                                <span v-if="paper.pub_year">.{{paper.pub_year}}</span>
                                            </span>
                                        </p>
                                        <div style="border: 1px solid #efefef; border-radius: 5px;">
                                            {{paper.summary_brief}}
                                        </div>
                                        <a-row style="margin-top: 20px" align="bottom">
                                            <a-col span="8">
                                                <paper-qrcode :href="href"/>
                                            </a-col>
                                            <a-col span="16" style="text-align: right;line-height: 18px">
                                                <PaperSlogan :height="isPhone? 65: 100" align="right"/>
                                                <small>扫描二维码，阅读完整图文</small>
                                            </a-col>
                                        </a-row>
                                    </div>
                                    <div style="position: absolute;  top: 21px; z-index: 5">
                                        <img alt="" width="100%" id="imageElement">
                                    </div>
                                </a-col>
                                <a-col span="2">
                                    <p v-if="isPhone">
                                        <span class="circle" @click="copyImg" v-if="!imgData">
                                            <PictureOutlined/>
                                        </span>
                                    </p>
                                    <p v-else>
                                        <span class="circle" @click="copyImg">
                                            <CopyOutlined/>
                                        </span>
                                    </p>
                                    <p>
                                        <span class="circle">
                                            <DownloadOutlined @click="generateImg"/>
                                        </span>
                                    </p>
                                </a-col>
                            </a-row>
                        </a-modal>
                    </div>
                </a-col>
                <a-col span="12" v-if="!isPhone">
                    <div class="content">

                        <PdfHighlight
                                v-if="paper.pdf_url"
                                ref="pdfViewer1"
                                :pdf-url1="isDEV?'/test2.pdf': paper.pdf_url"
                                :pdf-url=" paper.pdf_url"
                                :active-span="mineruData"
                                :initial-page="1"
                                @page-changed="onPageChanged"
                                @highlight-added="onHighlightAdded"
                                @highlight-removed="onHighlightRemoved"
                        />
                    </div>
                </a-col>
            </a-row>
        </a-spin>
    </div>
</template>

<script>
    import {PictureOutlined, PictureTwoTone, ShareAltOutlined, CopyOutlined, DownloadOutlined, RightOutlined, ReadOutlined} from '@ant-design/icons-vue';
    import {isDEV, get_args} from "../utils/request";
    import {
        post_biogpt_upload_share,
        post_biogpt_subscribe_share_paper,
        post_biogpt_paper_upload_info
    } from "../utils/bioinfo.api";
    import {
        jy_tip,
        exportAsImage,
        downImg,
        // copyImageUrl,
        copyImageToClipboard,
        // captureAsImage,
        checkStatus, copyImageToClipboardByPhone
    } from "../utils/vue.tool";
    import SimpleCode from "../components/SimpleCode";
    import ShowAll from "../components/ShowAll";
    import AuthorOrganization from "../components/AuthorOrganization";
    import PaperChat from "./PaperChat";
    import PdfHighlight from "../components/PdfHighlight";
    import LoadingComponent from "../components/LoadingComponent";
    // import PdfPpt from "../components/PdfPpt";
    import PdfPptAudio from "../components/PdfPptAudio";
    import PdfImg from "../components/PdfImg";
    // import PaperVideoSteps from "../components/PaperVideoSteps";
    import PaperWaitSteps from "../components/PaperWaitSteps";
    import RollBack from "../components/RollBack";
    import VoicePaper from '../components/VoicePaper';
    import PubmedMedia from './PubmedMedia';
    import PaperQrcode from './PaperQrcode';
    import MobileImg from './mobile/MobileImg';
    // import PaperDetailMobile from "./mobile/PaperDetailMobile";
    import {isLogin, isMobile, isPhone, jumpToLogin} from "../utils/llm.tools";
    import {post_auth_token_confirm} from "../utils/paper.account";
    import SafeIcon from "../components/SafeIcon";
    import PaperSlogan from "../components/PaperSlogan";
    export default {
        name: "PaperDetail",
        components: {
            PictureOutlined,
            PictureTwoTone,
            ReadOutlined,
            PaperSlogan,
            VoicePaper,
            SafeIcon,
            MobileImg,
            // PaperDetailMobile,
            RightOutlined,
            ShowAll,
            AuthorOrganization,
            SimpleCode,
            PubmedMedia,
            PaperQrcode,
            PaperChat,
            ShareAltOutlined,
            CopyOutlined, DownloadOutlined,
            PdfHighlight,
            PdfImg,
            // PdfPpt,
            PdfPptAudio,
            LoadingComponent,
            // PaperVideoSteps,
            PaperWaitSteps,
            RollBack
        },
        data(){
            let {upload_no, keyword, paper_no, share_code} = get_args();
            return {
                text: '### 系统框架与算法\n' +
                    '#### 1. 临床试验设计\n' +
                    '本研究采用单臂、单中心、开放标签的II期临床试验设计。\n' +
                    '\n' +
                    '*   **研究流程**：\n' +
                    '    *   **纳入**：连续纳入符合条件的广泛期小细胞肺癌（ES-SCLC）患者。\n' +
                    '    *   **诱导治疗**：患者接受4个周期的卡铂（AUC 5–6 mg/mL/min，每个周期第1天）+依托泊苷（80–100 mg/m²，每个周期第1-3天）+恩沃利单抗（300 mg，Q3W，每个周期化疗后第3天）。\n' +
                    '    *   **维持治疗**：诱导治疗后，使用恩沃利单抗进行维持治疗，直至疾病进展或出现不可耐受的毒性。\n' +
                    '\n' +
                    '#### 2. 生物标志物探索\n' +
                    '采用Olink靶向蛋白组学技术，对治疗前及治疗早期的血清样本进行分析，以探索潜在的预后生物标志物。\n' +
                    '\n' +
                    '---\n' +
                    '\n' +
                    '### 数据集构建\n' +
                    '#### 1. 数据集来源与规模\n' +
                    '*   **数据集类型**：前瞻性收集的临床试验患者队列。\n' +
                    '*   **数据规模**：患者从单一研究中心连续纳入，具体人数未明确说明，符合II期临床试验的典型规模。\n' +
                    '*   **数据用途**：用于评估恩沃利单抗联合化疗（卡铂-依托泊苷）作为ES-SCLC一线治疗的疗效、安全性，以及探索生物标志物。\n' +
                    '\n' +
                    '#### 2. 数据预处理与标注\n' +
                    '*   **血清样本**：收集了患者治疗前及治疗早期的血清样本。\n' +
                    '*   **蛋白组学数据**：使用Olink靶向蛋白组学技术，对循环免疫相关蛋白进行高通量分析，获得定量蛋白表达数据。\n' +
                    '\n' +
                    '\n' +
                    '### 评估体系\n' +
                    '#### <span class="paper-primary-tag">1.</span> 主要评价指标\n' +
                    '无进展生存期（PFS）。\n' +
                    '\n' +
                    '#### <span class="paper-primary-tag">2.</span> 次要/其他评价指标\n' +
                    '*   总生存期（OS）。\n' +
                    '*   最佳总体缓解率（ORR），及其95%置信区间。\n' +
                    '*   患者人口统计学特征、诊断和治疗信息、基线肿瘤检测结果。\n' +
                    '\n' +
                    '#### <span class="paper-primary-tag">3.</span> 统计分析方法\n' +
                    '*   **生存分析**：采用Kaplan-Meier方法估计中位PFS和OS。\n' +
                    '*   **置信区间计算**：使用Clopper和Pearson方法计算最佳总体缓解的95%置信区间。\n' +
                    '*   **描述性统计**：采用描述性方法分析基线特征等数据。\n' +
                    '*   **生物标志物分析**：对蛋白质组学数据进行差异表达分析和生存分析。\n' +
                    '*   **软件与显著性**：使用SAS 9.4和R 4.0.3进行统计分析，显著性水平设为p<0.05。\n' +
                    '\n' +
                    '\n' +
                    '### 应用及验证\n' +
                    '#### 1. 实际应用场景\n' +
                    '评估皮下注射的恩沃利单抗联合卡铂和依托泊苷作为广泛期小细胞肺癌一线治疗的疗效和安全性。\n' +
                    '\n' +
                    '#### 2. 实验验证\n' +
                    '*   **疗效验证**：通过评估PFS、OS、ORR等临床终点，验证联合治疗方案的临床获益。\n' +
                    '*   **生物标志物探索验证**：通过蛋白质组学分析，识别与患者预后（如PFS）相关的循环蛋白标志物，为精准治疗提供潜在依据。',
                shareTip: 'Voice paper 未完整生成，当前仅支持流式收听，完整生成后可分享。',
                isDEV,
                step: 0,
                showQuanwenText: false,
                checked1: true,
                loading: true,
                openQRCode: false,
                playBoke: false,
                mineruData: {},
                pubmed: {keyword: keyword || ''},
                upload_no: Number(upload_no),
                paper_no: Number(paper_no),
                share_code: share_code,
                shareable: isDEV,
                account: isLogin(),
                href: window.location.href,
                progress: 0,
                height: 60,
                showPPT: false,
                showVedio: false,
                showFullVideo: false,
                showFullText: false,
                paper: {
                    // videoData: 'http://drai.cn/video/demo/20250717_102123_s41586-025-09227-0.mp4',
                    // audioData: 'http://drai.cn/audio/demo/20250717_102123_s41586-025-09227-0.wav'
                },
                open: false,
                modalTitle: '',
                modalData: '',
                imgData: '',
                aiItems: [
                    {title: '要点总结', key: 'summary'},
                    {title: '研究方法', key: 'research_method'},
                    {title: '关键创新点', key: 'key_innovation'},
                    {title: '局限性', key: 'limitations'},
                ],
                searchKeyword: '',
                pageNumber: 1,
                isViewerLoaded: false,
                isPhone: isMobile(),
                ppt: require('@/json/ppt-payload'),
                videos: [
                    "https://www.vipaper.com/store/audio/demo/single_1.mp3",
                    "https://www.vipaper.com/store/audio/demo/single_2.mp3",
                    "https://www.vipaper.com/store/audio/demo/single_3.mp3",
                    "https://www.vipaper.com/store/audio/demo/single_4.mp3",
                    "https://www.vipaper.com/store/audio/demo/single_5.mp3",
                    "https://www.vipaper.com/store/audio/demo/single_6.mp3"
                ]
            }
        },
        created(){
            let {paper_no, upload_no, share_code} = this;
            if(share_code){
                this.getPaperDetail();
            }
            else post_auth_token_confirm(res=>{
                let {status} = res;
                if(status !== 1) {
                    if(!isDEV) jumpToLogin();
                }
                else {
                    this.getPaperDetail();
                    post_biogpt_upload_share({upload_no, paper_no}, (res)=>{
                        if(res?.data?.share_code) {
                            this.href = window.location.origin + window.location.pathname + window.location.search+ '&share_code=' + (res.data.share_code)
                        }
                    });
                    if(isDEV){
                        let timer = setInterval(()=>{
                            if(this.step > 5){
                                clearInterval(timer);
                                return;
                            }
                            this.step += 1;
                        }, 2000)
                    }
                }
            });

        },
        methods: {
            getPaperDetail(){
                let {paper_no, share_code, upload_no} = this;
                if(upload_no) {
                    if(share_code) post_biogpt_subscribe_share_paper({share_code, paper_no, upload_no}, this.handleDetailRes);
                    else post_biogpt_paper_upload_info({paper_no, upload_no}, this.handleDetailRes);
                }
            },
            handleDetailRes(res){
                this.loading = false;
                let {data, message} = res;
                if(data){
                    let {upload_status: newStatus, video_parse_info, embedding} = data;
                    this.paper = {...data};
                    this.progress = newStatus;
                    // let showV = video_parse_info?.step === 4;
                    let showV = checkStatus(newStatus, 4);
                    this.showVedio = showV;
                    this.shareable = checkStatus(newStatus, 10);
                    if(!showV) {
                        console.log('======showVedio======', showV, video_parse_info?.step);
                        setTimeout(()=>{
                            this.getPaperDetail();
                        }, 5000)
                    }else if(embedding === 1){
                        setTimeout(()=>{
                            this.getPaperDetail();
                        }, 5000)
                    }
                } else jy_tip(message);
            },

            showModal(title, data){
                this.open = true;
                this.modalTitle = title;
                this.modalData = data;
            },
            copyImg(){
                // generateIm
                if(this.imgData) this.handleCopyImg(this.imgData);
                else exportAsImage(document.getElementById('card'), (imgData)=>{
                    this.imgData = imgData;
                    this.handleCopyImg(this.imgData);
                })
            },
            handleCopyImg(){
                if(isPhone) copyImageToClipboardByPhone(this.imgData, 'imageElement', 'mobile-tip');
                else copyImageToClipboard(this.imgData);
            },
            generateImg(){
                // generateIm
                if(this.imgData) downImg(this.imgData);
                else exportAsImage(document.getElementById('card'), (imgData)=>{
                    this.imgData = imgData;
                    downImg(imgData);
                })
            },
            //pdf相关
            onViewerLoaded() {
                this.isViewerLoaded = true;
                // jy_tip('PDF加载完毕', 'success');
            },
            handleSearchText(searchKeyword) {
                searchKeyword = searchKeyword.trim();
                if (searchKeyword) {
                    if (this.isViewerLoaded) {
                        this.$refs.pdfViewer.highlightKeyword(searchKeyword);
                    }
                }

            },
            clearHighlight() {
                // 通过触发一个空搜索来“清除”高亮，但这并非真正清除，只是高亮了空字符串（视觉上无变化）
                // 另一种思路是直接重新加载iframe，但这会丢失当前页面状态
                if (this.isViewerLoaded) {
                    this.$refs.pdfViewer.highlightKeyword('');
                    this.searchKeyword = '';
                }
            },
            handlePageJump(page) {
                this.pageNumber = typeof page === 'string' ? Number(page?.split('-')[0]): page;
                if (this.isViewerLoaded && this.pageNumber) {
                    this.$refs.pdfViewer.jumpToPage(this.pageNumber);
                }
            },
            handleMinus(mineruData) {
                this.mineruData = {...mineruData};
                console.log('mineruData', mineruData);
                if(mineruData){
                    if (this.$refs.pdfViewer1) {
                        console.log('handleMinus', this.$refs.pdfViewer1.addHighlight);
                        // 添加高亮
                        this.$refs.pdfViewer1.addHighlight( mineruData.page + 1, mineruData);
                    }
                    if(isPhone) {
                        this.showModal(mineruData.name, mineruData.paragraph);
                    }
                }

            },
            handleBoke(){
                this.playBoke = true;
            },
            goToRecent(){
                if(isPhone) window.location.href = '/recent';
            },
            goToPubmed(){
                let href = 'https://pubmed.ncbi.nlm.nih.gov/' + this.paper.pmid;
                window.open(href, '_blank')
            },
            fankui(){
                jy_tip('感谢您的反馈，问题已提交。')
            },
            toggleTab(){
                this.checked1 = !this.checked1;
            },
            showQuanwen(show){
                if(show) {
                    console.log('showQuanwen');
                }
            }
        }
    }
</script>

<style scoped>
    .paper-detail {padding: 10px;}

    .height90, .content {
        height: 92vh;
        font-size: 18px!important;
        overflow-y: auto;
    }
    .content {
        background: #FAFAFA;
        border-radius: 10px;
        padding: 1%;
    }
    .content-left{
        padding: 10px 20px;
    }
    .content1{
        background: #FFF;
        border-radius: 8px;
        margin-bottom: 15px;
        padding: 10px;
    }
    .auto-wrap {
        word-wrap: break-word!important; /* 旧版浏览器支持 */
        overflow-wrap: break-word!important; /* 标准属性 */
        word-break: break-all;
        /*white-space: nowrap;不换行*/
    }
    .v-tab{
        margin: 10px 0; padding: 10px 0; background: #EAE8EB; border-radius: 25px; text-align: center
    }
    .active-tab{;
        background: #FFF;
        border-radius: 25px;
    }
    .tab-left, .tab-right{
        padding: 10px 18%;
        font-size: 16px;
        cursor: pointer;
    }
    .tab-left{
        /*margin-right: 40px;*/
    }
    .tab-right{
        /*margin-left: 50px*/
    }
    /* 在你的项目的CSS文件中覆盖 */
    .textLayer .highlight {
        background-color: #FEFFE0 !important; /* 红色半透明高亮 */
    }
    .modal-width{
        max-width: 960px;
    }
    .ai-title{
        color: #4472C4; font-size: 18px; font-weight: 500;
    }
    .circle{
        border-radius: 20px;
        display: block;
        background: #eeeeee;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
    }
    /*{*/
    /*  xs: '480px',*/
    /*  sm: '576px',*/
    /*  md: '768px',*/
    /*  lg: '992px',*/
    /*  xl: '1200px',*/
    /*  xxl: '1600px',*/
    /*}*/
    /* 当视口宽度小于 600px 时 */

    @media (max-width: 1600px) {
        .tab-left, .tab-right{
            padding: 10px 15%;
        }
    }
    @media (max-width: 480px) {
        .height90, .content {
            height: 100%;
        }
        .content{
            background: #FFF;
        }
        .paper-detail {padding: 0;background: #FFF;}
        .pubmed-width {
            width: 100%;
            /*border: 1px solid red;*/
            overflow-wrap: break-word!important; /* 标准属性 */
            word-break: break-all;
        }
        .modal-width{
            width: 98%
        }
        .content {
            padding: 0;
        }
        .content-left{
            padding: 0;
        }
        .tab-left, .tab-right{
            padding: 10px 12%;
        }
    }

    /* 隐藏滚动条 */
    ::-webkit-scrollbar {
        width: 0; /* 设置滚动条宽度 */
    }

    /* 滚动条轨道 */
    ::-webkit-scrollbar-track {
        background-color: #f1f1f1; /* 设置滚动条轨道背景颜色 */
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        background-color: #999; /* 设置滚动条滑块颜色 */
    }

    /* 滚动条滑块悬停状态 */
    ::-webkit-scrollbar-thumb:hover {
        background-color: #555; /* 设置滚动条滑块悬停状态颜色 */
    }


    /*CSS代码：*/
    /* src/styles/components/collapse.css */
    .ant-collapse-blue-arrow .ant-collapse-item .ant-collapse-header .ant-collapse-arrow {
        color: #576B95 !important;
        transition: color 0.3s;
    }

    .ant-collapse-blue-arrow .ant-collapse-item .ant-collapse-header:hover .ant-collapse-arrow {
        color: #576B95 !important;
    }

    .ant-collapse-blue-arrow .ant-collapse-item-active .ant-collapse-header .ant-collapse-arrow {
        color: #576B95 !important;
    }


</style>